<template>
  <div>
    <div style="margin-bottom:1.5em;">
      <h3 class="mainTitle">Just nu</h3>
      <p class="descr">Här nedanför kan du se alla enheter i din Nexa Bridge som just nu är aktiva på något sätt, exempelvis magnetkontakter som är öppna, rörelsevakter som detekterar rörelse eller liknande. Enheterna försvinner automatiskt från vyn när de inte längre är aktiva.</p>
    </div>

    <div v-for="cap in caps" style="margin-bottom:20px;" v-if="nodesForCapAndValue(cap, '===', true).length">
      <h4>{{ $root.capabilities[cap].name }}</h4>

      <table>
        <tbody>
          <tr v-for="node in nodesForCapAndValue(cap, '===', true)" @click="showNode(node.id)">
            <td>{{ node.name }}</td>
            <td align="right">{{ node.lastEvents[cap].time | moment("calendar") }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'nu',
    data: () => ({
      caps: [
        'notificationSmoke',
        'notificationContact',
        'notificationMotion',
        'notificationWater'
      ]
    }),
    created () {},
    methods: {
      showNode (nodeId) {
        this.$router.push({
          name: 'enhet',
          params: {
            id: nodeId
          }
        })
      },
      
      nodesForCapAndValue (capability, comparator, value) {
        let nodes = []
        
        // Loopa alla noder
        this.$root.data.nodes.forEach(node => {
          
          // Kolla så noden har capabilityn samt att det finns ett värde
          if (node.capabilities.includes(capability) && capability in node.lastEvents) {
            const event = node.lastEvents[capability]
            
            // Kolla så att vi har en komparator samt ett värde definierat
            if (comparator != undefined && value != undefined) {
              
              // Jämför nuvarande värdet på enheten mot det som vi har angivit
              if (this.compare(event.value, comparator, value)) {
                nodes.push(node)
              }
            }
          }
        })
      
        return nodes
      },
      
      compare(value, comparator, to) {
        switch (comparator) {
          case '===': return value === to; break
          case '>': return value > to; break
        }
      }
    },
    computed: {},
    destroyed () {}
  }
</script>



// WEBPACK FOOTER //
// src/components/nu.vue